export const CONFIG = {

  // GTM
  GTM_ID : 'GTM-KZNTCVJ',

  // Sentry
  SENTRY_DSN : 'https://951a8537425c4ff7b397aa6223e93e79@sentry.landmarksid.com/4',

  // mapbox
  MAPBOX_TOKEN: 'pk.eyJ1IjoibGFuZG1hcmtzIiwiYSI6ImNqd2xyYzdoZDEzODM0OW4wMWZpbXFhMDUifQ.JertTnfIn9vKhUsoX943ZA',
  MAPBOX_STYLE_URL : 'cjwlmdzov0ao81crzsp3shho0',
};
